// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__vctKf","item":"PaymentsMobile_item__YfF65","label":"PaymentsMobile_label__30P0V","amount":"PaymentsMobile_amount__1bu_W"};